import * as XLSX from "xlsx";

export function downloadExcel(data, name) {
  // const workbook_template = XLSX.read(excell_base64_template, { type: "base64" });
  // var first_sheet_name = workbook_template.SheetNames[0];
  // var worksheet_t = workbook_template.Sheets[first_sheet_name];

  // XLSX.utils.sheet_add_json(worksheet_t, data, { origin: "A7" });

  // XLSX.utils.book_append_sheet(workbook_template, worksheet_t, "Sheet2");
  // XLSX.writeFile(workbook_template, name);

  const dateObject = new Date();
  const _userData = JSON.parse(localStorage.getItem("userData"));
  const worksheet = XLSX.utils.json_to_sheet(data, { origin: "A5" });
  XLSX.utils.sheet_add_aoa(worksheet, [["AENSA ECUADOR"]], { origin: "A1" });
  XLSX.utils.sheet_add_aoa(
    worksheet,
    [
      [
        "Fecha:",
        dateObject.toLocaleDateString("en-IN") +
          " " +
          dateObject.getHours() +
          ":" +
          dateObject.getMinutes(),
      ],
    ],
    {
      origin: "A2",
    }
  );
  XLSX.utils.sheet_add_aoa(
    worksheet,
    [
      [
        "Reporte generado por :",
        _userData.name + " " + _userData.lastName,
        "Empresa:",
        _userData.company.name,
      ],
    ],
    {
      origin: "A3",
    }
  );

  // const max_width = data.reduce((w, r) => Math.max(w, r.name.length), 10);
  // worksheet["!cols"] = [{ wch: 50 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, name);
}
